import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import '../../styles/CommonStyles.css';
import authService from '../../services/authService';

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setError('');
  };
  
  const validateEmail = (email) => {
    const emailRegex = /\S+@\S+\.\S+/;
    return emailRegex.test(email);
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Reset states
    setError('');
    setSuccess(false);
    
    // Validate email
    if (!email.trim()) {
      setError('Email address is required');
      return;
    }
    
    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      // Call the auth service to request password reset
      await authService.requestPasswordReset(email);
      setSuccess(true);
    } catch (err) {
      console.error('Password reset request error:', err);
      setError(err.response?.data?.error || 'Unable to process your request. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="page-container">
      <Header />
      
      <div className="page-header">
        <h1>FORGOT PASSWORD</h1>
        <p>Reset your BVA member account password</p>
      </div>
      
      <section className="content-section">
        <div className="login-container" style={{ 
          maxWidth: '500px', 
          margin: '0 auto',
          padding: '2rem',
          backgroundColor: 'white',
          borderRadius: '8px',
          boxShadow: 'var(--box-shadow)'
        }}>
          <h2 style={{ 
            textAlign: 'center', 
            marginBottom: '2rem',
            color: 'var(--primary-color)'
          }}>
            Forgot Password
          </h2>
          
          {!success ? (
            <>
              <p style={{ marginBottom: '1.5rem', textAlign: 'center' }}>
                Enter your email address and we'll send you instructions to reset your password.
              </p>
              
              {error && (
                <div style={{ 
                  padding: '0.75rem 1rem',
                  marginBottom: '1.5rem',
                  backgroundColor: '#f8d7da',
                  color: '#721c24',
                  borderRadius: '4px',
                  border: '1px solid #f5c6cb'
                }}>
                  {error}
                </div>
              )}
              
              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: '1.5rem' }}>
                  <label 
                    htmlFor="email" 
                    style={{ 
                      display: 'block', 
                      marginBottom: '0.5rem', 
                      fontWeight: '600' 
                    }}
                  >
                    Email Address
                  </label>
                  <input 
                    type="email" 
                    id="email" 
                    value={email}
                    onChange={handleEmailChange}
                    style={{ 
                      width: '100%', 
                      padding: '0.8rem', 
                      borderRadius: '4px', 
                      border: '1px solid #ddd',
                      fontSize: '1rem'
                    }}
                  />
                </div>
                
                <button 
                  type="submit" 
                  className="btn btn-primary"
                  disabled={isSubmitting}
                  style={{ 
                    width: '100%',
                    padding: '0.8rem',
                    backgroundColor: 'var(--primary-color)',
                    color: 'white',
                    fontSize: '1rem',
                    opacity: isSubmitting ? 0.7 : 1
                  }}
                >
                  {isSubmitting ? 'SUBMITTING...' : 'RESET PASSWORD'}
                </button>
              </form>
            </>
          ) : (
            <div style={{ 
              padding: '1rem',
              marginBottom: '1.5rem',
              backgroundColor: '#d4edda',
              color: '#155724',
              borderRadius: '4px',
              border: '1px solid #c3e6cb',
              textAlign: 'center'
            }}>
              <p style={{ marginBottom: '1rem' }}>
                <strong>Password reset email sent!</strong>
              </p>
              <p>
                We've sent instructions to reset your password to {email}. 
                Please check your inbox and follow the instructions in the email.
              </p>
            </div>
          )}
          
          <div style={{ 
            textAlign: 'center', 
            marginTop: '2rem',
            borderTop: '1px solid #eee',
            paddingTop: '1.5rem'
          }}>
            <p style={{ marginBottom: '1rem' }}>
              Remember your password?
            </p>
            <Link to="/member-login" style={{ 
              textDecoration: 'none',
              color: 'var(--primary-color)',
              fontWeight: '500'
            }}>
              Back to Login
            </Link>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
}

export default ForgotPasswordPage;
